var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"loading-screen"},[_c('div',{staticClass:"loading-info"},[_c('span',[_vm._v("Please wait...")]),_c('Loader')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }